module.exports = __webpack_public_path__ + "img/charcoal.90dd3667.png";